<script setup lang="ts">
// Esta rota (que já existe em prod — rotas NOVAS são bloqueadas no deploy) é a
// entrada de deep-link da roletinha: abre o modal global e volta pra home. A
// roleta antiga do Smartico (que vivia aqui sob ?legacy=1) foi removida junto
// com o fallback da store — sem roleta no core, o aviso de indisponível aparece
// dentro do próprio sheet (ver stores/roulette.ts).
const { standardTitleSuffix } = getStandardSeoSuffixes();

useSeo({
  title: `Roletinha ${standardTitleSuffix}`,
});

onMounted(() => {
  useRouletteStore().open();
  navigateTo(localeLink('/'), { replace: true });
});
</script>

<template>
  <div />
</template>
